import Dropdown from "components/dropdown/dropdown.component"
import Input from "components/input/input.component"

const ManageUsersFilter = ({
    isGenerateReport = false,
}: {
    isGenerateReport?: boolean
}) => {
    return (
        <div
            className={`flex flex-col gap-5 filter-shipment p-4 overflow-auto ${isGenerateReport && '!py-2'} `}
        >
            <div className="flex-col w-full">
                <Input label="USER ID" placeholder="Enter Shipment ID" />
            </div>
            <div className="flex-col w-full">
                <Dropdown
                    options={[
                        {
                            label: 'Admin Staff',
                            value: 'Admin Staff',
                        },
                        {
                            label: 'Customer Service',
                            value: 'Customer Service',
                        },
                        {
                            label: 'Warehouse Manager',
                            value: 'Warehouse Manager',
                        },
                        {
                            label: 'Logistics Coordinator',
                            value: 'Logistics Coordinator',
                        },
                    ]}
                    label="JOB TITLE"
                    onClick={() => { }}
                    placeholder="Select User Job Title"
                    isClearable={true}
                    isMultiSelect={true}
                    isSearchable={true}
                    dropDownIndicator={true}
                />
            </div>
            <div className="flex-col w-full">
                <Dropdown
                    options={[
                        {
                            label: 'Logistics',
                            value: 'Logistics',
                        },
                        {
                            label: 'Operations',
                            value: 'Operations',
                        },
                    ]}
                    label="JOB CATEGORY"
                    onClick={() => { }}
                    placeholder="Select User Job Category"
                    isClearable={true}
                    isMultiSelect={true}
                    isSearchable={true}
                    dropDownIndicator={true}
                />
            </div>
            <div className="flex-col w-full">
                <Dropdown
                    options={[
                        {
                            label: 'Admin',
                            value: 'Admin',
                        },
                        {
                            label: 'Regular User',
                            value: 'Regular User',
                        },
                    ]}
                    label="ROLE"
                    onClick={() => { }}
                    placeholder="Select User Role"
                    isClearable={true}
                    isMultiSelect={true}
                    isSearchable={true}
                    dropDownIndicator={true}
                />
            </div>
            <div className="flex-col w-full">
                <Dropdown
                    options={[
                        {
                            label: 'Organization',
                            value: 'Organization',
                        },
                        {
                            label: 'Last Access',
                            value: 'Last Access',
                        },
                    ]}
                    onClick={() => { }}
                    placeholder="Add Filter"
                    isClearable={true}
                    isMultiSelect={true}
                    isSearchable={true}
                    dropDownIndicator={true}
                />
            </div>
        </div>
    )
}

export default ManageUsersFilter